module.exports = __webpack_public_path__ + "static/media/icon-more-vertical.3dc9c6f2.svg";